export enum DictCodeEnmu {
    //客户类型
    CUSTOMER_TYPE = 'customer-type',
    //客户属性
    CUSTOMER_ATTR = 'customer-attr',
    //供应商类型
    SUPPLIER_TYPE = 'supplier-type',

    //配件类型（商品类型）
    MATERIAL_TYPE = 'material-type',
    //商品类别
    MATERIAL_TYPECATEGORY = 'material-typeCategory',
    //计量单位
    MATERIAL_UNIT = 'unit',
    //配件品牌
    MATERIAL_BRAND = 'material-brand',
    //发动机型号
    ENGINE_TYPE = 'engine-type',

    // 采退类型
    PRETURN_TYPE = 'preturn-type',
    // 普通
    PRETURN_TYPE_GENERAL = 'preturn-type.general',
    // 不受限
    PRETURN_TYPE_LIMIT = 'preturn-type.not-limit',

    //开户银行类型
    OPENBANK_TYPE = 'account-bank',
    //账户类型
    ACCOUNT_TYPE = 'account-type',
    //发票类型
    INVOICE_TYPE = 'invoice-type',
    //发票状态
    INVOICE_STATUS = 'invoice-status',
    //支付状态
    PAY_STATUS = 'pay-status',
    //支付方式
    PAY_METHOD = 'pay-method',
    //支付方式（纯现金类）
    PAY_METHOD_CASH = 'pay-method.cash',
    //支付方式（现金账户类）
    PAY_METHOD_ACCT = 'pay-method.acct',
    //经济实体
    BENTITY = 'bentity',
    //核销状态
    WRITE_OFF_STATUS = 'write-off-status-test',

    //采购单状态
    PURCHASE_STATUS = 'purchase-status',
    //采购单状态(调拨采)
    PURCHASE_STATUS_ALLOCATION = 'purchase.allocation',
    //采购单状态(已补单)
    PURCHASE_STATUS_REPLENISH = 'pur-replenish-status.replenish',
    //采购单状态(已结算)
    PURCHASE_STATUS_BILL = 'purchase-status.bill',
    //采购单状态(已作废)
    PURCHASE_STATUS_CHANGE = 'purchase.change',
    //采购单状态(已入库)
    PURCHASE_STATUS_COMPLETELY_IO = 'purchase.completely-io',
    //采购单状态(已开单)
    PURCHASE_STATUS_CREATE = 'purchase-status.create',

    //采购类型
    PURCHASE_TEPE = 'purchase-type',
    //采购退货单状态
    PURCHASE_RETURN_STATUS = 'purchase-return-status',
    //采购退货单状态(已结款)
    PURCHASE_RETURN_STATUS_SETTLE_PUR = 'pur-return-status.settle',
    //采购退货单状态(已作废)
    PURCHASE_RETURN_STATUS_CHANGE = 'purchase-return.change',
    //采购退货单状态(已出库)
    PURCHASE_RETURN_STATUS_STOCK_IO = 'purchase-return.stock-io',
    //采购退货单状态(已结算)
    PURCHASE_RETURN_STATUS_SETTLE = 'purchase-return.settle',
    //采购退货单状态(已开单)
    PURCHASE_RETURN_CREATE = 'purchase-return.create',

    //销售订单状态
    SALE_ORDER_STATUS = 'sale-order-status',
    //销售订单状态(已开单)
    SALE_ORDER_STATUS_CREATE = 'sale-order.create',
    //销售订单状态(已作废)
    SALE_ORDER_STATUS_CHANGE = 'sale-order.change',
    //销售订单状态(已转接)
    SALE_ORDER_STATUS_TRANSFER = 'sale-order.transfer',

    //销售价格类型
    SALE_PRICE_TYPE = 'sale-price-type-test',
    //销售单状态
    SALE_STATUS = 'sale-status',
    //销售单状态(调拨销)
    SALE_STATUS_ALLOCATION = 'sale.allocation',
    //销售单状态（已补单）
    SALE_STATUS_REPLENISH = 'sale-replenish-status.replenish',
    //销售单状态（已结算）
    SALE_STATUS_SETTLE = 'sale.settle',
    //销售单状态（已作废）
    SALE_STATUS_CHANGE = 'sale.change',
    //销售单状态（已出库）
    SALE_STATUS_STOCK_IO = 'sale.stock-io',
    //销售单状态（已开单）
    SALE_STATUS_CREATE = 'sale.create',

    //销售退货单状态
    SALE_RETURN_STATUS = 'sale-return-status',
    //销售退货单状态(已结款)
    SALE_RETURN_STATUS_WRITE_OFF = 'sale-return-status.write-off',
    //销售退货单状态（已作废）
    SALE_RETURN_STATUS_CHANGE = 'sale-return-status.change',
    //销售退货单状态（已结算）
    SALE_RETURN_STATUS_SETTLE = 'sale-return-status.settle',
    //销售退货单状态（已入库）
    SALE_RETURN_STATUS_STOCK_IO = 'sale-return-status.stock-io',
    //销售退货单状态（已开单）
    SALE_RETURN_STATUS_CREATE = 'sale-return-status.create',

    //销售类型
    SALE_TYPE = 'sale-type',
    //维修类型
    REPAIR_TYPE = 'repair-type',
    //工单类型
    MAINTENANCEORDER_TYPE = 'maintenanceOrder-type',
    //三包单位
    MAINTENANCESB_BRAND = 'maintenanceSB-brand',
    //维修类型 维修服务
    REPAIR_TYPE_REPAIR = 'repair-type.repair',
    //维修类型 事故车维修
    REPAIR_TYPE_ACCIDENT_AVEHICLE = 'repair-type.accident-vehicle',
    //维修类型 零件质保
    REPAIR_TYPE_MATERIAL_WARRANTY = 'repair-type.material-warranty',
    //维修类型 保养服务
    REPAIR_TYPE_MAINTENANCE = 'repair-type.maintenance',
    //维修类型 保养合约
    REPAIR_TYPE_MAINTAIN = 'repair-type.maintain',
    //维修类型 索赔服务
    REPAIR_TYPE_CLAIM = 'repair-type.claim',
    //维修类型 其他
    REPAIR_TYPE_OTHER = 'repair-type.other',
    //车辆类型
    VEHICLE_TYPE = 'vehicle-type',
    //审批类型
    APPROVAL_TYPE = 'approval-type',
    //仓库类型
    CK_TYPE = 'warehouse-type', //之前"ck",
    //采购单状态
    PURCHASE = 'purchase',
    //采购单退货状态
    PURCHASE_RETURN = 'purchase-return-status',
    //销售单状态
    SALE = 'sale-status',
    //销售退货状态
    SALE_RETURN = 'sale-return-status',
    // 结算类型
    SETTLE_TYPE = 'settle-type',
    //结算类型 (挂账)
    SETTLE_TYPE_CREDIT = 'settle-type.credit',
    //结算类型 （现结）
    SETTLE_TYPE_CASH = 'settle-type.cash',
    //结算类型 （结转）
    SETTLE_TYPE_BALANCE = 'settle-type.balance',

    //单据类型
    TRADE_TYPE = 'trade-type',
    //单据类型 (销售单)
    TRADE_TYPE_SO = 'trade-type.sale',
    //单据类型 (销售订单)
    TRADE_TYPE_SORDER = 'trade-type.sale-order',
    //单据类型 ( 销售退货）
    TRADE_TYPE_SRO = 'trade-type.sale-return',
    //单据类型 (采购单)
    TRADE_TYPE_PO = 'trade-type.purchase',
    //单据类型 (采购退货)
    TRADE_TYPE_PRO = 'trade-type.purchase-return',
    //单据类型 (维修单)
    TRADE_TYPE_MO = 'trade-type.maintenance',
    //单据类型 (维修退单)
    TRADE_TYPE_MRO = 'trade-type.maintenance.return',

    //维修单状态
    MAINTENANCE = 'maintenance',
    //维修单状态 审核通过
    MAINTENANCE_APPROVED = 'maintenance.approved',
    //维修单状态 审核中
    MAINTENANCE_UNDER_REVIEW = 'maintenance.under-review',
    //维修单状态 已作废
    MAINTENANCE_CHANGE = 'maintenance.change',
    //维修单状态 已完工
    MAINTENANCE_COMPLETED = 'maintenance.completed',
    //维修单状态 已终检
    MAINTENANCE_STATUS_FINAL = 'maintenance-status.final',
    //维修单状态 已回访
    MAINTENANCE_RETURN_VISIT = 'maintenance.return-visit',
    //维修单状态 已结款
    MAINTENANCE_WRITE_OFF = 'maintenance.write-off',
    //维修单状态 在修
    MAINTENANCE_UNDERWAY = 'maintenance.underway',
    //维修单状态 待修
    MAINTENANCE_AWAIT = 'maintenance.await',
    //维修单状态 已转接
    MAINTENANCE_TRANS = 'maintenance.trans',
    //维修单状态 已出库
    MAINTENANCE_STOCK_IO = 'maintenance.stock-io',
    //维修单状态 已结算
    MAINTENANCE_SETTLE = 'maintenance.settle',
    //维修单状态 已开单
    MAINTENANCE_CREATE = 'maintenance.create',

    //维修退单状态
    MAINTENANCE_RETURN = 'maintenance.return',
    //维修退单状态 退单已审
    MAINTENANCE_RETURN_APPROVE = 'maintenance.chargeback.approve',
    //维修退单状态 退单待审
    MAINTENANCE_RETURN_PEND = 'maintenance.chargeback.pend',
    //维修退单状态 已开单
    MAINTENANCE_RETURN_CREATE = 'maintenance.return.create',
    //维修退单状态 已结算
    MAINTENANCE_RETURN_SETTLE = 'maintenance.return.settle',
    //维修退单状态 已入库
    MAINTENANCE_RETURN_IO = 'maintenance.return.io',
    //维修退单状态 已作废
    MAINTENANCE_RETURN_CHANGE = 'maintenance.return.change',
    //预约状态
    APPOINTMENT = 'appointment',
    //预约状态 已转接
    APPOINTMENT_TRANSFER = 'appointment.transfer',
    //预约状态 已作废
    APPOINTMENT_CHANGE = 'appointment.change',
    //预约状态 已开单
    APPOINTMENT_CREATE = 'appointment.create',
    //车辆品牌
    VEHICLE_BRAND = 'vehicle-brand',
    //服务性质
    SERVICE_TYPE = 'service-type', //之前"service-type",
    //服务地点
    SERVICE_ADDRESS = 'service-address',
    //服务地点
    INQUIRY_TYPE = 'Inquiry-type',
    //三包单位
    CLAIMUNIT = 'claim-unit',

    //盘点单状态
    STOCKTAKING = 'stocktaking-status',
    // 盘点单状态(已完成)
    STOCKTAKING_COMPLETE = 'stocktaking.complete',
    // 盘点单状态(已审核)
    STOCKTAKING_AUDIT = 'stocktaking.audit',
    // 盘库单状态(进行中)
    STOCKTAKING_CREATE = 'stocktaking.create',
    //采购计划状态
    PURCHASE_PLAN = 'purchase-plan',
    //采购审批状态
    PURCHASE_APPROVAL_STATUS = 'purchase-approval-status',
    //采购询价状态
    PURCHASE_ENQUIRY_STATUS = 'purchase-enquiry-status',
    //是否直发(直发类型)
    DIRECT_TYPE = 'direct-flag',
    //物流方式
    LOGISTIC_MODE = 'transport-mode',
    //组织机构
    ORG = 'cm-organization',
    //站点
    SHOP = 'cm-shop',
    //站点类型
    SHOP_TYPE = 'shop-type',
    //经济实体
    BE = 'cm-business-entity',
    //结算方
    SETTLE_PARTY = 'settle-party',
    //结算方（部门内部结算）
    SETTLE_PARTY_INTERNAL = 'settle-party.internal',
    //结算方（客户自费）
    SETTLE_PARTY_SELF_PAY = 'settle-party.self-pay',
    //结算方（大包维修）
    SETTLE_PARTY_DABAOMAINTENANCE = 'settle-party.dabaomaintenance',

    //销售订单状态
    SALE_ORDER = 'sale-order-status',
    // 销售订单状态(已转接)
    SALE_ORDER_TRANSFER = 'sale-order.transfer',
    //收款人
    PAYEE = 'payee',
    //回访单状态
    VISIT_STATUS = 'visit-status',
    //回访方式
    RETURN = 'return',
    //
    //账户类型 （配件返利）
    ACC_TYPE_REBATE = 'account-type.rebate',
    //账户类型 （油品返利）
    ACC_TYPE_REBATE_OIL = 'account-type.rebate-oil',
    //账户类型 （投放）
    ACC_TYPE_MARKET = 'account-type.credit-market',
    //账户类型 （配件投放）
    ACC_TYPE_DELIVERY = 'account-type.credit-delivery',
    //账户类型 (月结)
    ACC_TYPE_Month = 'account-type.credit-month',
    //账户类型 (临时授信)
    ACC_TYPE_Credit = 'account-type.credit',
    //账户类型 (现金账户)
    ACC_TYPE_CASH = 'account-type.cash',
    //账户类型（结转账户）
    ACC_TYPE_JZ = 'account-type.jz',
    //账户类型（备品四方）
    ACC_TYPE_SPARE_AGREEMENT = 'account-type.spare-agreement',
    //账户类型（油品四方）
    ACC_TYPE_OILS_AGREEMENT = 'account-type.oils-agreement',

    //结算类型
    PAYEE_TYPE = 'settle-type',
    //盘点类型
    // TRADE_TYPE = "trade-type"

    //调拨状态
    TRANSFER_STATUS = 'transfer-status',
    //调拨状态(待调出)
    TRANSFER_STATUS_INIT = 'transfer-status.init',
    //调拨状态(待调入)
    TRANSFER_STATUS_OUT = 'transfer-status.out',
    //调拨状态(已调入)
    TRANSFER_STATUS_IN = 'transfer-status.in',

    //调拨类型
    TRANSFER_TYPE = 'transfer-type',
    //备品调拨
    TRANSFER_TYPE_BP = 'transfer-type.bp',
    //其它调拨
    TRANSFER_TYPE_OTHERS = 'transfer-type.others',

    //销售类型
    SALES_TYPE = 'sale-type',
    // 正常销售
    SALES_TYPE_NORMAL = 'sales-type.normal-sales',
    //售价选择
    PRICE_SELECTION = 'sale-price-type',
    // PRICE_SELECTION = "price-selection",
    //采购类型
    PURCHASE_TYPE = 'purchase-type',
    //优惠类型
    PREFERENTIAL_TYPE = 'preferential-type',
    //仓库类型
    WAREHOUSE_TYPE = 'warehouse-type',
    WAREHOUSE_TYPE_DIRECT = '999-zf', //直发
    WAREHOUSE_TYPE_LAUNCH = 'tf', //投放

    // 销售实体
    BENTITY_BJ_YH_AUTO_SERVICE = 'bentity.bj-yh-auto-service',//云豪车服（北京）科技服务有限公司
}

export const sourceAppOrBranch = {
    sourceApp: "vrm",
    branch: "vrm",
}
export const orgCodeOrName = {
    orgCode: "vrm",
    orgName: "vrm",
}
